const PostList = require("app/components/posts/PostList");
const GroupedList = require("app/components/lists/StaticGroupedList");

class LatestPosts extends GroupedList {

	static get defaultProps() {
		return {
			title: translate("Nyt fra Bloggen"),
			subtitle: translate("Bloomit blog"),
			items: []
		};
	}

	get className() {
		return "grouped-list static-grouped-list latest-posts";
	}

	renderGroup(item) {
		return (
			<PostList displayDate={false} items={item.items}/>
		);
	}

}

module.exports = LatestPosts;
